import { FormEvent, useEffect, useState } from "react";
import { DropshipProps } from "../Dropship";
import { formToObject } from "../../../utils/generic";
import {
  DROPSHIP_PERMISSIONS,
  patchDropship,
} from "../../../services/dropship";
import { useTranslation } from "react-i18next";
import Select from "../../../components/dom/Select";
import {
  PAYMENT_METHODS_PERMISSIONS,
  getAllPaymentMethods,
  getPaymentMethod,
  iPaymentMethod,
} from "../../../services/payment";
import { useSelector } from "react-redux";
import { selectUser } from "../../../store/userSlice";
import Button from "../../../components/dom/Button";
import { useNavigate } from "react-router-dom";
import { PaymentDetails } from "../../AccountSettings/sub/PaymentSettings";
import { selectGroup } from "../../../store/groupSlice";
import { GROUP_PERMISSIONS } from "../../../services/groups";

export default function DropshipPayments({
  dropship,
  onRefresh,
}: DropshipProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const { t } = useTranslation();
  const [paymentMethod, setPaymentMethod] = useState<iPaymentMethod>();
  const [paymentmethods, setPaymentmethods] = useState<iPaymentMethod[]>([]);
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const group = useSelector(selectGroup);

  const isAdmin = () => {
    return user.isAdmin;
  };

  const setPaymentMethodSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const data = formToObject(e.target);
      await patchDropship(data);

      onRefresh?.();
      setIsEdited(false);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const loadPaymentMethod = async () => {
    setIsLoading(true);
    try {
      const data = await getPaymentMethod(dropship._id);
      setPaymentMethod(data);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const canSeePayment = () => {
    if (user.isAdmin) return true;

    const myGroupPerms = group.members?.find(
      (e) => e.email === user.email
    )?.permissions;

    if (
      myGroupPerms?.includes(GROUP_PERMISSIONS.admin) ||
      myGroupPerms?.includes(GROUP_PERMISSIONS.dropship)
    )
      return true;

    const myCollectionPerms = dropship.members?.find(
      (e) => e.email === user.email
    )?.permissions;

    if (
      myCollectionPerms?.includes(DROPSHIP_PERMISSIONS.admin) ||
      myCollectionPerms?.includes(DROPSHIP_PERMISSIONS.view_payment_data)
    )
      return true;

    return false;
  };

  const loadPaymentMethods = async () => {
    setIsLoading(true);
    try {
      const data = await getAllPaymentMethods();
      setPaymentmethods(data);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (canSeePayment()) {
      loadPaymentMethods();

      if (dropship.paymentMethodId) loadPaymentMethod();
    }

    // eslint-disable-next-line
  }, [dropship]);

  return (
    <section className="dropship-sub-page dropship-payments">
      <br />
      <form onSubmit={setPaymentMethodSubmit}>
        <label htmlFor="">{t("payment.name")}</label>
        <input
          type="text"
          hidden
          defaultValue={dropship._id}
          name="dropshipId"
        />
        <Select
          disabled={isLoading}
          name="paymentmethodId"
          onChange={(e: any) => {
            setIsEdited(true);
            setPaymentMethod(
              paymentmethods.find((p) => p._id === e.target.value)
            );
          }}
          className="payment-method-select"
          value={paymentMethod?._id}
          defaultValue={paymentMethod?._id ?? "0"}
          options={[
            {
              value: "0",
              text: String(t("payment.select")),
              disabled: true,
            },
            ...paymentmethods.map((p) => {
              return {
                text: isAdmin()
                  ? `${p.name} - ${
                      p.members.find((m) =>
                        m.permissions.includes(
                          PAYMENT_METHODS_PERMISSIONS.admin
                        )
                      )?.email
                    }`
                  : p.name,
                value: p._id,
              };
            }),
          ]}
        />
        <div className="mt-3">
          <Button
            onClick={() => navigate("/account/payment")}
            small
            text={String(t("payment.create_new"))}
          />
        </div>
        <br />
        <div>
          <Button
            type="submit"
            loading={isLoading}
            light={!isEdited}
            // disabled={!isEdited}
            text={String(t("dropship.save"))}
          />
        </div>
      </form>
      <hr />
      {paymentMethod && dropship.paymentMethodId === paymentMethod._id ? (
        <>
          <br />
          <PaymentDetails
            hidePayouts
            refresh={loadPaymentMethod}
            // dropshipId={dropship._id}
            noactions
            payment={paymentMethod}
          />
          <hr />
        </>
      ) : null}
    </section>
  );
}
